import {TextField, withStyles} from "@material-ui/core";

const CustomFilterPadded = withStyles({
    selected: {paddingLeft: "15px"},

    root: { paddingLeft: "15px",
        '& label.Mui-focused': {
            color: '#00338d',
        },
        '& .MuiInput-underline:before': {
            borderBottomColor: '#00338d',
            borderBottomWidth: 2,
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: '#00338d',
        },
        '& .MuiInputBase-input.Mui-disabled': {
            color: '#000000',
        },
        '& .MuiInput-underline.Mui-disabled:before': {
            borderBottomStyle: 'none',
        },
        '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
            borderBottomColor: '#00338d',
        },
        '& .MuiOutlinedInput-root': {
            '&.Mui-focused fieldset': {
                borderColor: '#00338d',

            }
        }
    }
})(TextField);

export default CustomFilterPadded;
